module.exports = __webpack_public_path__ + "img/x3_2025_04_25@2x.fe775038.png";